import { render, staticRenderFns } from "./HelpCenter.vue?vue&type=template&id=6100e2c8&scoped=true"
import script from "./HelpCenter.vue?vue&type=script&lang=ts"
export * from "./HelpCenter.vue?vue&type=script&lang=ts"
import style0 from "./HelpCenter.vue?vue&type=style&index=0&id=6100e2c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6100e2c8",
  null
  
)

export default component.exports